/**
 * Sign up process.
 */

'use strict';

var helper = require('../misc/helpers');

// Constructor
var FrontNewsletter = function () {
    $(document).ready((function () {
        this.subscribeFormFooter();
        this.subscribeFormPopup();
    }).bind(this));
};

FrontNewsletter.prototype = {
    lockAjaxForm: false,

    handleSubmit: function(form, popup) {
        var self = this;

        if (this.lockAjaxForm) {
            // Pending AJAX request... wait
            return;
        }

        this.lockAjaxForm = true;

        var msgNewsletter = $('#newsletter-popup .check span').text();
        if (popup) {
            if (!$('#newsletter-popup input[name="check"]').is(':checked')) {
                alert('Veuillez cocher la case "' + msgNewsletter + '"');
                this.lockAjaxForm = false;
                return;
            }
        } else {
            if (!$('#newsletter_not_signed').is(':checked')) {
                alert('Veuillez cocher la case "' + msgNewsletter + '"');
                this.lockAjaxForm = false;
                return;
            }
        }

        $('.submit', form).hide();
        $('.response', form).hide();
        $('.loading', form).fadeIn(500);

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: form.serialize() + "&action=newsletter.subscribeform&security=" + comedien.security,
        }).done(function(response) {
            $('.loading', form).fadeOut(500);

            if (response.success) {
                $('.fields', form).hide();
                $('.response', form).removeClass('error').addClass('success');
                $('.response', form).text(comedien.i18n.newsletterFormSuccess).show();
                $('input[type="email"]', form).removeClass('invalid').addClass('valid');
                if (popup) {
                    $('#newsletter-popup .check').hide();
                } else {
                    $('#front-newsletter .check-newsletter').hide();
                }
            } else {
                $('.submit', form).show();
                $('.response', form).removeClass('success').addClass('error');
                $('.response', form).text(comedien.i18n.newsletterFormError).show();
                $('input[type="email"]', form).removeClass('valid').addClass('invalid');
            }

            helper.setCookie('newsletter_form_popup', 1, 336); // 2 weeks

            self.lockAjaxForm = false;
        }).fail(function(jqXHR, textStatus) {
            self.lockAjaxForm = false;

            console.log("Request failed: " + textStatus);

            $('.submit', form).show();
            $('.loading', form).fadeOut(500);
            $('.response', form).removeClass('success').addClass('error');
            $('.response', form).text(comedien.i18n.newsletterFormError).show();
        });
    },

    /**
     * Handle the newsletter subscription form (on footer).
     */
    subscribeFormFooter: function() {
        var self = this;

        $('#newsletter-subscribe-form').submit(function(e) {
            e.preventDefault();

            self.handleSubmit($(this), false);
        });
    },

    /**
     * Handle the newsletter subscription form (on footer).
     */
    subscribeFormPopup: function() {
        var self = this;

        var cookie = helper.getCookie('newsletter_form_popup');

        if (cookie == '1') {
            // The user has already subscribed to the newsletter.
            // Do not show the newsletter popup again (lifetime: 2 weeks).
            $('#newsletter-popup').hide();
        } else {
            $('#newsletter-popup').show();
        }

        $('#newsletter-subscribe-form-popup').submit(function(e) {
            e.preventDefault();

            self.handleSubmit($(this), true);
        });

        $('#newsletter-popup .close').on('click', function(e) {
            e.preventDefault();

            $('#newsletter-subscribe-form-popup input').val('');

            var height = $('#newsletter-popup').height();

            $('#newsletter-popup').animate({
                bottom: "-" + height + "px"
            }, 500);

            helper.setCookie('newsletter_form_popup', 1, 336); // 2 weeks
        });
    }
};

module.exports = new FrontNewsletter();
